// TaskColumn.jsx
import React from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { formatDateToDDMMMYYYY } from '../../utils/dateFormatter';

const getStatusClass = (status) => {
  switch (status) {
    case 'Overdue':
      return 'overdue';
    case 'Due today':
      return 'today';
    case 'Due this week':
      return 'week';
    case 'Due next week':
      return 'nextweek';
    case 'No deadline':
      return 'nodeadline';
    default:
      return '';
  }
};


const TaskColumn = ({ status, tasks, columnId }) => {
       const navigate=useNavigate();
       const handleEdit = (event,task) => {
    
    let taskid=task?.TasksId
    navigate(`/task/taskdetails/${taskid}`);
  };
  return (
    <div className={`task-column ${getStatusClass(status)}`}>
      <h4>{status}</h4>
      <Droppable droppableId={columnId}>
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {tasks.map((task, index) => (
              <Draggable key={task.TasksId} 
              draggableId={String(task.TasksId)} index={index}>
                {(provided) => (
                  <div
                    className="task-card"
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    <div className="task-title" onClick={(e) => handleEdit(e, task)}>{task.TaskName}</div>
                    {task.TaskEndDate && (
                      <div className="task-deadline">
                        {formatDateToDDMMMYYYY(task.TaskEndDate)}
                      </div>
                    )}
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  );
};

export default TaskColumn;
